import { UrlSanitise } from "../../fetchHelpers";
import { Query } from "../apiTypes";
import { GetTokenManually } from "../WebPortalTokenClient";

declare const accountServerUrl;

interface AccountError {
    code: string;
    generated: string;
    id: string;
    message: string;
    meta: any;
}

export function isAccountModelWithError(
    model: any
): model is AccountError {
    if (model === undefined || model === null) return false;
    return (<AccountError>model).code !== undefined && (<AccountError>model).message !== undefined;
}

const handleResponse = async (response: Response) => {
    const json = await response.json();

    if (isAccountModelWithError(json))
        throw Error(`${json.message} (${json.code})`);
    else
        return json;
}

export const ApiMe = (): Promise<Response> => {
    return fetch(`${UrlSanitise(accountServerUrl)}api/v1/me`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${GetTokenManually()?.access_token}`
        },
    });
}

export const ApiClients = (query: Query<any>): Promise<any> => {
    return fetch(`${UrlSanitise(accountServerUrl)}api/v1/clients`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${GetTokenManually()?.access_token}`
        },
        body: JSON.stringify(query)
    })
        .then(handleResponse)
}

export const ApiGetClientById = (id: string): Promise<any> => {
    return fetch(`${UrlSanitise(accountServerUrl)}api/v1/clients/${id}`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${GetTokenManually()?.access_token}`
        },
    })
        .then(handleResponse)
}

export const ApiPutClientById = (id: string, model: any): Promise<any> => {
    return fetch(`${UrlSanitise(accountServerUrl)}api/v1/clients/${id}`, {
        method: 'PUT',
        headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${GetTokenManually()?.access_token}`
        },
        body: JSON.stringify(model)
    })
        .then(handleResponse)
}

export const ApiGetCountries = (): Promise<any> => {
    return fetch(`${UrlSanitise(accountServerUrl)}api/v1/countries`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${GetTokenManually()?.access_token}`
        },
    })
        .then(handleResponse)
}

export const ApiUsers = (query: Query<any>): Promise<any> => {
    return fetch(`${UrlSanitise(accountServerUrl)}api/v1/users`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer ${GetTokenManually()?.access_token}`
        },
        body: JSON.stringify(query)
    })
        .then(handleResponse)
}
